// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const varoom: PokeData = {
  "id": 965,
  "name": "varoom",
  "height": 10,
  "weight": 350,
  "base_experience": 60,
  "types": [
    PokeType.STEEL,
    PokeType.POISON
  ],
  "api_moves": [
    "headbutt",
    "screech",
    "lick",
    "smog",
    "sludge",
    "poison-gas",
    "swagger",
    "uproar",
    "taunt",
    "gyro-ball",
    "assurance",
    "poison-jab",
    "gunk-shot",
    "iron-head",
    "spin-out"
  ],
  "moves": [
    "headbutt",
    "lick",
    "poison-gas",
    "poison-jab",
    "toxic-overload",
    "stun-spore",
    "mortal-gas",
    "venom-drench",
    "purify",
    "scrap-throw",
    "acid-rain",
    "toxic-spikes",
    "behemoth-bash"
  ],
  "evolution_chain": {
    "id": 505,
    "item": null,
    "species": [
      {
        "name": "varoom",
        "order": 942,
        "types": [
          PokeType.STEEL,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "revavroom",
        "order": 943,
        "types": [
          PokeType.STEEL,
          PokeType.POISON
        ],
        "evolves_from_species_id": 965,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 49.5,
    "speed": 47,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
